import {
    ContentDetailInfoShell,
    ContentDetailThreeColLayout,
    DetailFilePanel,
    DetailKvListValue,
    DetailKvReadOnly,
    DetailKvTable,
    DetailPanel,
    DetailSummaryButton,
    KV_LIST_TYPES,
} from "../../../../components/detailLayout";
import React from "react";
import ReadOnlyInputBasic from "../../../../components/input/ReadOnlyInputBasic";
import Th_title from "../../../../components/Th_title";
import SimmsDatePicker from "../../../../components/datepicker/SimmsDatePicker";
import {ContentCategory, ContentStatus} from "../../../../constant/CodeSpecNum";
import ApprovalComponent from "../../../settings/approval/new/ApprovalComponent";
import {DisposeVerification} from "./DisposeVerification";
import {isMobile} from "../../../../components/commonmethod/CommonMethod";
import {useNavigate} from "react-router-dom";
import {removeDisposes} from "../../../../api/lifecycle/dispose/DisposeService";

function DisposeInfo({id, dispose, assets, statusNumericValue}) {
    const navigate = useNavigate();

    const remove = async () => {
        const response = await removeDisposes({ids: [id]});
        if (response.status === 200) {
            alert("자산폐기가 정상적으로 삭제되었습니다.");
            navigate("/lifecycle/dispose");
        }
    };

    const canAccept =
        dispose.auth?.update && statusNumericValue === ContentStatus.PRE_INSERT.statusNumericValue;

    const summaryMeta = [
        dispose.requestCode?.name && `종류 ${dispose.requestCode.name}`,
        dispose.number && `번호 ${dispose.number}`,
    ]
        .filter(Boolean)
        .join(" · ");

    const requestInfoPanel = (
        <>
            <DetailPanel title="폐기요청자산">
                <DetailKvTable>
                    <tbody>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title="자산목록" colspan={3} className="fieldset-td relative align-top">
                                <DetailKvListValue items={assets} listType={KV_LIST_TYPES.asset} />
                            </Th_title>
                        </tr>
                    </tbody>
                </DetailKvTable>
            </DetailPanel>

            <DetailPanel title="요청정보">
                <DetailKvTable>
                    <tbody>
                        <tr>
                            <DetailKvReadOnly label="등록일시" value={dispose.createdAt} type="date" />
                            <DetailKvReadOnly label="수정일시" value={dispose.updatedAt} type="date" />
                        </tr>
                        <tr>
                            <DetailKvReadOnly label="등록자" value={dispose.createdBy?.name} />
                            <DetailKvReadOnly label="수정자" value={dispose.updatedBy?.name} />
                        </tr>
                        <tr>
                            <Th_title title="요청자" colspan={3} className="fieldset-td">
                                <ReadOnlyInputBasic target="requester" value={dispose.requester?.name} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title="요청종류" colspan={3} className="fieldset-td">
                                <ReadOnlyInputBasic target="requestCode" value={dispose.requestCode?.name} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title="요청일" colspan={3} className="fieldset-td fieldset-td-input">
                                <div className="web-flex asset-detail-date-range">
                                    <SimmsDatePicker data={dispose.requestStartDate} readonly />
                                    <span className="asset-detail-date-range-sep">~</span>
                                    <SimmsDatePicker data={dispose.requestEndDate} readonly />
                                </div>
                            </Th_title>
                        </tr>
                    </tbody>
                </DetailKvTable>
            </DetailPanel>
        </>
    );

    const workflowPanels = (
        <>
            <DisposeVerification data={dispose} />
            <DetailPanel title="요청내용">
                <DetailKvTable>
                    <tbody>
                        <tr>
                            <Th_title title="요청번호" colspan={3} className="fieldset-td">
                                <ReadOnlyInputBasic target="number" value={dispose.number} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title="검수자" colspan={3} className="fieldset-td">
                                <ReadOnlyInputBasic target="inspector" value={dispose.inspector?.name} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title="제목" colspan={3} className="fieldset-td">
                                <ReadOnlyInputBasic target="name" value={dispose.name} />
                            </Th_title>
                        </tr>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title="내용" colspan={3} className="fieldset-td">
                                <div className="align-text-div">{dispose.content}</div>
                            </Th_title>
                        </tr>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title="기타" colspan={3} className="fieldset-td">
                                <div className="align-text-div">{dispose.etc}</div>
                            </Th_title>
                        </tr>
                    </tbody>
                </DetailKvTable>
            </DetailPanel>
        </>
    );

    const asidePanel = (
        <>
            <ApprovalComponent contentId={dispose.id} contentCategory={ContentCategory.DISPOSE} />
            <DetailFilePanel
                title="첨부"
                isEditing={Boolean(dispose.auth?.update)}
                tableInfo={{tableName: "dispose", joinKey: dispose.id}}
            />
        </>
    );

    return (
        <ContentDetailInfoShell
            title={dispose.name || "자산폐기 상세"}
            meta={summaryMeta || undefined}
            contentId={id}
            contentCategory={ContentCategory.DISPOSE}
            scrollMode="columns"
            listUrl="/lifecycle/dispose"
            actions={
                canAccept ? (
                    <DetailSummaryButton onClick={() => navigate(`/lifecycle/dispose/update/${id}`)}>
                        접수하기
                    </DetailSummaryButton>
                ) : null
            }
            rollup={{
                remove:
                    !isMobile &&
                    dispose.auth?.delete &&
                    statusNumericValue !== ContentStatus.COMPLETE.statusNumericValue
                        ? remove
                        : "",
            }}
        >
            <ContentDetailThreeColLayout
                primary={requestInfoPanel}
                secondary={workflowPanels}
                aside={asidePanel}
            />
        </ContentDetailInfoShell>
    );
}

export {DisposeInfo};
